import type { ZabitBridge } from '../../renderer/src/global';

/**
 * Mağaza üzerinden abonelik — yalnızca mobil uygulamada
 * (mobile/src/shims/storeBilling.ts). Web'de abonelik iyzico ile.
 */
export const storeBilling: ZabitBridge['storeBilling'] = undefined;
